// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const TransactionType = {
  SalesOrder: {
    Name: 'Sales Order',
    Value: 'sales_order',
    Label: 'Order',
  },
  Invoice: {
    Name: 'Invoice',
    Value: 'invoice',
    Label: 'Invoice',
  },
  Payment: {
    Name: 'Payment',
    Value: 'payment',
    Label: 'Payment',
  },
  Adjustment: {
    Name: 'Adjustment',
    Value: 'adjustment',
    Label: 'Adjustment',
  },
  RefundRequest: {
    Name: 'Refund Request',
    Value: 'refund_request',
    Label: 'Refund Request',
  },
  ReturnAuthorization: {
    Name: 'Return Authorization',
    Value: 'return_authorization',
    Label: 'Return Authorization',
  },
  ReturnAdjustment: {
    Name: 'Return Adjustment',
    Value: 'return_adjustment',
    Label: 'Return Adjustment',
  },
  ReturnPayment: {
    Name: 'Return Payment',
    Value: 'return_payment',
    Label: 'Return Payment',
  },
  FeeReturn: {
    Name: 'Fee Return',
    Value: 'fee_return',
    Label: 'Fee Return',
  },
  RefundReversal: {
    Name: 'Refund Reversal',
    Value: 'refund_reversal',
    Label: 'Refund Reversal',
  },
  DepositApplication: {
    Name: 'Deposit Application',
    Value: 'deposit_application',
    Label: 'Deposit Application',
  },
} as const

export type TransactionTypeValue = (typeof TransactionType)[keyof typeof TransactionType]['Value']
